import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import service from "../../../images/services.jpg";

const OurTeam = () => {
  return (
    <Box>
      <Box
        width={"100%"}
        margin={{ xs: "25% 0%", sm: "5% 0%" }}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "40%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant="h4"
            color="#33E68C"
            fontWeight={800}
            paddingBottom={"1%"}
            textAlign={"left"}
          >
            <Typography
              component={"span"}
              color="#000"
              fontWeight={800}
              variant={"h4"}
            >
              Our {""}
            </Typography>
            Team
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            Our team consists of the best minds in engineering, product design,
            graphics design, data analysis and brand managers. We pull our
            collective efforts and ideas together to ensure we give value to our
            clients and deliver only world-class products that our clients love
            and are satisfied with. As a team, we are geared towards excellence
            and it reflects on our products.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            paddingTop={"2%"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
          >
            Whether you are looking to establish an online presence for your
            business or need a complex web application built, our team has the
            skills and experience to deliver a solution that exceeds your
            expectations. Let us help bring your digital vision to life. Contact
            us today to get started
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          data-aos={"fade-up"}
        >
          <img src={service} alt={"services"} width={"100%"} height={"100%"} />
        </Box>
      </Box>
    </Box>
  );
};

export default OurTeam;
